export interface Place {
  id: number;
  place_city: string;
  place_country: string;
  place_state: string;
  place_postcode?: string;
}

export enum AttendingEventType {
  HOST = 'Host',
  CONFIRMED = 'Confirmed',
  TENTATIVE = 'Tentative',
  REFUSED = 'Refused',
  REQUESTED = 'Requested'
}

export interface AttendingEvent {
  id: number;
  activity_title: string;
  activity_description: string;
  start_date_time: string;
  end_date_time: string;
  type: AttendingEventType;
  places: Place[];
  visuals?: Array<{ image_url: string }>;
}

export interface AttendingEventStatusParams {
  activityId: AttendingEvent["id"];
  status: AttendingEventType;
}

export interface ShortIdValidation {
  valid: boolean | null;
  message: string | null;
}

export interface FetchAttendingEventsParams {
  page: number;
  limit: number;
}

export interface Pagination {
  current_page: number;
  limit: number;
  total_items: number;
  total_pages: number;
}

export interface AttendingEventsResponse {
  data: AttendingEvent[];
  pagination: Pagination;
}

export interface AttendingEventsState {
  currentPage: AttendingEventsResponse;
  firstPage: AttendingEvent[];
  data: AttendingEvent[];
  loading: boolean;
  error: string | null;
}




